import styled from "styled-components";

export const ConhecaAquabitStyle = styled.div`
    
`;